module.exports = __webpack_public_path__ + "img/0-127.2a1c84cc.jpg";